// extracted by mini-css-extract-plugin
export default {"list":"index_list_cdtk1","img":"index_img_9i2Sm"};